import React from "react";
import { Link } from "react-router-dom";
import Media from "react-media";

import { DesktopNav, MobileNav } from "./nav";
import Logo from "./Logo";
import Footer from "./Footer";
import styles from "./styles";

const Layout = ({ children }) => (
  <section style={styles.container}>
    {/* response nav */}
    <Media query="(max-width: 699px)">
      {(matches) => {
        return (
          <nav style={styles.nav}>
            <Link to="/">
              <Logo matches={matches} />
            </Link>
            {matches ? <MobileNav /> : <DesktopNav />}
          </nav>
        );
      }}
    </Media>
    <div style={styles.content}>{children}</div>
    <Footer />
  </section>
);

export default Layout;



// WEBPACK FOOTER //
// ./src/components/Layout/index.js